export enum ModuloEnum {
  Master = 1,
  Home = 2,
  InteligenciaDados = 3,
  Desenvolvedor = 4,
  Tintas = 5,
  Suporte = 8,
  Implantacao = 9,
}
